import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { API_ENDPOINTS, buildApiUrl } from '@/constants';
import { api } from '@/utils';

interface QualityScoreFormulaResponse {
    formulaId: string | null;
}

/**
 * Custom hook that fetches the quality score formula ID for a campaign.
 * The formula is cached indefinitely until explicitly invalidated (when questions are saved).
 *
 * @param {number | null} campaignId - Campaign ID
 * @returns {QueryResult<QualityScoreFormulaResponse, AxiosError>} - Query result
 */
export const useQualityScoreFormula = (campaignId: number | null) => {
    return useQuery<QualityScoreFormulaResponse, AxiosError>({
        queryKey: ['qualityScoreFormula', campaignId],
        queryFn: async () => {
            if (!campaignId) {
                return { formulaId: null };
            }

            const url = buildApiUrl(API_ENDPOINTS.GET_CAMPAIGN_QUESTIONS_CALCULATE_FORMULA(campaignId));
            const response = await api.get(url);

            return response.data;
        },
        enabled: !!campaignId,
        staleTime: Infinity,
        gcTime: Infinity,
        retry: 2,
    });
};
